export default class FeeScheduleBillingCode {
  private readonly _value: string;

  constructor(value: string) {
    this._value = value;
  }

  public isEqualTo(other: FeeScheduleBillingCode): boolean {
    return this.value === other?.value;
  }

  public get value(): string {
    return this._value;
  }

  public static get Prototype(): FeeScheduleBillingCode {
    return new FeeScheduleBillingCode("");
  }

  public fromJSON(value: string): FeeScheduleBillingCode {
    return new FeeScheduleBillingCode(value);
  }
  public toJSON(): string {
    return this.value;
  }
  public clone(): FeeScheduleBillingCode {
    return new FeeScheduleBillingCode(this.value);
  }
}
